import { IconButton } from '@lune-fe/lune-ui-lib'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Navigation source identifiers
 * Used to track where users navigate from for proper back navigation
 */
export enum NavigationSource {
    IMPORTS = 'imports',
    HOMEPAGE = 'homepage',
    CALCULATE_EMISSIONS = 'calculate-emissions',
    ANALYTICS = 'analytics',
}

/**
 * Back button that navigates based on location state
 *
 * This component handles back navigation by checking where the user came from.
 * If `location.state.from` is a valid NavigationSource, it navigates to that route.
 * Invalid or missing values default to /calculate-emissions.
 *
 * @example
 * Navigate with state
 * navigate('/some-form', { state: { from: NavigationSource.IMPORTS } })
 *
 * In the form component
 * <BackButtonWithFromState /> // Will navigate back to /imports
 * ```
 */
const BackButtonWithFromState = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const from = location.state?.from
    const isValidSource = Object.values(NavigationSource).includes(from)

    const backPath = isValidSource
        ? from === NavigationSource.HOMEPAGE
            ? '/'
            : `/${from}`
        : `/${NavigationSource.CALCULATE_EMISSIONS}`

    return (
        <IconButton
            style="floating"
            leadingIcon={<ArrowBackOutlinedIcon />}
            sx={{
                ml: -1.5,
            }}
            onClick={() => navigate(backPath)}
        />
    )
}

export default BackButtonWithFromState
